module.exports = __webpack_public_path__ + "static/eleclab-f7ec03f9408eca0e5123cef09baf70be.jpg";